import {useRef} from 'react';
import {sendMonitor} from '../../../../utils/monitoring';

type Props = {
    setFile: (file: File[]) => Promise<void>;
    hasData: boolean;
    monitor?: {send: boolean; text: string};
};

export const useDropzone = (props: Props) => {
    const {setFile, hasData, monitor} = props;
    const dropzoneRef = useRef<HTMLDivElement>(null);
    const draggingRef = useRef(false);

    const onDragStart = e => {
        e.preventDefault();

        const dropZoneEl = dropzoneRef.current;
        const isEmpty = !hasData;

        if (dropZoneEl && !draggingRef.current && isEmpty) {
            dropZoneEl.classList.add('pui-on-drag-enter');
            draggingRef.current = true;
        }
    };

    const onDragLeave = (e?) => {
        e?.preventDefault();
        const dropZoneEl = dropzoneRef.current;

        if (dropZoneEl && draggingRef.current) {
            setTimeout(() => {
                draggingRef.current = false;
                dropZoneEl.classList.remove('pui-on-drag-enter');
            }, 200);
        }
    };

    const handleDrop = async e => {
        e.preventDefault();
        if (monitor?.send) {
            sendMonitor(monitor.text);
        }

        setFile(e?.dataTransfer?.files);
        onDragLeave();
    };
    return {
        dropzoneRef,
        handleDrop,
        onDragLeave,
        onDragStart
    };
};
